import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actActions from '../modules/actiondata';
import * as orderActions from '../modules/orderdata';
import * as locationActions from '../modules/locationdata';
import * as dashboardActions from '../modules/dashboarddata';
import * as customerActions from '../modules/customerdata';
import Home from './home';

class HomeContainer extends React.Component {
    render() {
        return (
            <Home
                actions={this.props.actions}
                overdueActions={this.props.overdueActions}
                overdueLeadTasks={this.props.overdueLeadTasks}
                upcomingLeadTasks={this.props.upcomingLeadTasks}
                fetching={this.props.fetching}
                authenticated={this.props.authenticated}
                pendingOrders={this.props.pendingOrders}
                getActionDataByMonthYear={this.props.getActionDataByMonthYear}
                getOverdueActionData={this.props.getOverdueActionData}
                getOverdueLeadTasks={this.props.getOverdueLeadTasks}
                getUpcomingLeadTasks={this.props.getUpcomingLeadTasks}
                newOrderFromLocations={this.props.newOrderFromLocations}
                history={this.props.history}
                userProfile={this.props.userProfile}
                customerDescriptionsOwn={this.props.customerDescriptionsOwn}
                getCustomerDescriptiveInfo={this.props.getCustomerDescriptiveInfo}
                customerDescriptionsOwnFetching={this.props.customerDescriptionsOwnFetching}
                configurableLeadStages={this.props.configurableLeadStages}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    actions: state.actiondata.actions,
    overdueActions: state.actiondata.overdueActions,
    overdueLeadTasks: state.dashboarddata.overdueLeadTasks,
    upcomingLeadTasks: state.dashboarddata.upcomingLeadTasks,
    fetching: state.actiondata.isFetchingActionData,
    authenticated: state.authentication.authenticated,
    pendingOrders: state.orderdata.pendingOrders,
    locationsById: state.locationdata.locationsById,
    userProfile: state.authentication.userProfile,
    customerDescriptionsOwn: state.customerdata.customerDescriptionsOwn,
    customerDescriptionsOwnFetching: state.customerdata.getCustomerDescriptionsOwnInProgress,
    configurableLeadStages:
        state.parameterdata && state.parameterdata.parameters ? state.parameterdata.parameters.LeadStage : null,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { ...actActions, ...orderActions, ...locationActions, ...dashboardActions, ...customerActions },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);
